// ───────── modifier-types.ts ─────────
import { z } from 'zod';
/** A single selectable option */
export const ProductModifierSchema = z.object({
    id: z.string(), // UUID
    name: z.string(),
    priceDelta: z.number().default(0), // +$0.50 for extra cheese, etc.
    costDelta: z.number().default(0),
    linkedProductId: z.string().nullable(), // point to an INVENTORY product if stock is tracked
    depletesInventory: z.boolean().default(false),
    isDefault: z.boolean().default(false), // helpful for “6 in” being the base price
});
/** A group of related modifiers */
export const ProductModifierGroupSchema = z.object({
    id: z.string(), // UUID
    name: z.string(), // e.g. "Sauce"
    required: z.boolean().default(false),
    min: z.number().int().default(0), // 0 means optional
    max: z.number().int().default(1), // 0 == unlimited
    sortOrder: z.number().int().default(0),
    modifiers: z.array(ProductModifierSchema),
});
// ───────── modifier-selection-types  ─────────
// One concrete option the cashier / customer chose
export const SelectedModifierSchema = z.object({
    modifierId: z.string(), // id from ProductModifierSchema
    name: z.string(),
    priceDelta: z.number().default(0),
    costDelta: z.number().default(0),
    linkedProductId: z.string().nullable(), // if inventory is decremented
    quantity: z.number().int().default(1), // for “double cheese”, etc.
});
// All choices within a group (e.g. “Drinks” group → Pepsi)
export const ModifierGroupSelectionSchema = z.object({
    groupId: z.string(), // id from ProductModifierGroup
    groupName: z.string(),
    selected: z.array(SelectedModifierSchema),
});
// For use in the checkout / sale item object
export const SelectedModifierDataSchema = z
    .array(ModifierGroupSelectionSchema)
    .default([])
    .optional();
